import clsx from 'clsx'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { isNil } from 'ramda'
import { useEffect, useState } from 'react'

const Collapse = ({
  open,
  title,
  key,
  toggleCollapse,
  children,
  customHeadTab = null,
  containerClassName = '',
  headerClassName = '',
  contentClassName = '',
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(open)
  const onClickCollapse = (event) => {
    if (disabled) {
      return // Prevent toggle when disabled
    }
    setIsOpen((prev) => !prev)
    toggleCollapse(event)
  }
  useEffect(() => {
    setIsOpen(open)
  }, [open])

  return (
    <div
      className={clsx(
        'rounded-8 text-blue-950 bg-white text-18',
        !containerClassName && 'border border-primary-350',
        containerClassName,
      )}
      key={key}
    >
      <button
        onClick={onClickCollapse}
        disabled={disabled}
        className={clsx(
          'flex items-center w-full text-blue-950 font-normal space-x-2',
          !headerClassName && 'px-5 sm:px-10',
          headerClassName,
          disabled && 'cursor-not-allowed',
        )}
      >
        <div
          className={clsx(
            'flex-1 text-left',
            !isNil(customHeadTab) && 'flex justify-between items-cente',
          )}
        >
          <span>{title}</span>
          {!isNil(customHeadTab) && customHeadTab}
        </div>

        {isOpen ? (
          <ChevronUp className="h-56 w-20" />
        ) : (
          <ChevronDown className="h-56 w-20" />
        )}
      </button>
      <div
        className={clsx(
          'bg-white',
          isOpen
            ? clsx(
                'visible h-auto',
                !contentClassName && 'px-5 sm:px-10 py-5 sm:py-10 pt-5',
                contentClassName,
              )
            : clsx(
                'invisible h-0 overflow-hidden',
                !contentClassName && 'p-0',
                contentClassName,
              ),
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default Collapse
